import Api from "@/repository/ApiBase";
import {GetChannelsResponse} from "@/repository/messagehub.dtos";
import {AxiosResponse} from "axios";
export class WhoAmIResult {
    success: boolean;
    userName: string;
    avatarUrl: string;
    email: string;
}
export class WhoAmIApi extends Api{
    constructor() {
        super();

    }
    async getWhoAmI(){
        let result: AxiosResponse =  await this.Client.get('/user/whoami')
        console.log("who am i response");
        if (result.status == 200){
            let data = new WhoAmIResult();
            data.success = true;
            data.userName = result.data.displayName;
            data.email = result.data.email;
            return data;
            //data.userName = result.data.data.Name
        }
        else{
            let data = new WhoAmIResult();
            data.success = true;
            return data;
        }
    }
    async getIsEmailMenuVisible(){
        let result: AxiosResponse =  await this.Client.get('/document/email/count')
        if (result.status == 200){
            let count = result.data.count;
            if (count >0){
                return true
            }
            else{
                return false
            }
        }
        else{
            return false;
        }
    }
}
export default WhoAmIApi;
